export enum HttpMethods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum EndPoints {
  Login = '/construct-auth-uri?authType',
  Logout = '/logout',
  GetTokens = '/get-tokens',
  RefreshToken = '/refresh-tokens',
  GetLink = '/get-import-url',
  AdminImportConsentUrl = '/admin-import-consent-url',
  GetGroups = '/get-groups?limit=50&order=asc',
  GetUsers = '/get-users?limit=50&order=asc',
  GetUserGroupDetails = '/get-user-groups',
  CompleteOnboardingFlow = '/change-on-boarding-status?status=update',
  GetCompleteOnboardingFlow = '/change-on-boarding-status?status=get',
  GetEndpoints = '/get-endpoints',
  GetAdminInvites = '/get-admins',
  InviteAdmin = '/send-invites',
  VerifyAdminInvite = '/verify-invite',
  GetImportStatus = '/get-import-status',
  DeleteAdmin = '/delete-admin',
  GetPolicyDetails = '/get-categories',
  Policies = '/policies',
  UpdatePolicyExceptions = '/exceptions',
  GetBypass = '/get-bypass?policyName=',
  UpdateBypass = '/update-bypass?policyName=',
  AddBypass = '/update-bypass?action=add',
  SearchUsersGroups = '/search-users-groups',
  GetBlockPages = '/get-block-pages',
  SettingsEndpointsConfig = '/endpoint-settings',
  GetPolicyAssignee = '/policy-assignment',
  AssignPolicy = '/assign-policy',
  UpdateDefaultBlockPages = '/update-dope-default-pages',
  UpdateCustomBlockPage = '/custom-pages',
  PoliciesTester = '/policies/test',
  ToggleEndpoint = '/toggle-endpoint',
  ShadowITApplication = '/shadow-it/apps',
  ShadowITUsers = '/shadow-it/users',
  GetAssociatedUsers = '/get-associated-users',
  GetEndpointMetadata = '/aggregations',
  GetActivityByTime = '/productivity/activity-time',
  GetProductivity = '/productivity/top-categories',
  GetDiagnosticResult = '/get-diagnostics-results',
  GetCloudApp = '/get-cac?policyName=',
  GetViolations = '/violation',
  GetTopTenBlocks = '/fe-violations/top-violations-by-entity',
  GetTopViolationsByType = '/fe-violations/top-violations-by-type',
  GetAnalyticsDetail = '/fe-violations/details',
  SubscriptionDetails = '/subscription',
  GetAuditLogs = '/get-audit',
  UpdateCac = '/update-cac',
  GenerateInstaller = '/get-cloud-bundle-url',
  GetViolationsOverview = '/fe-violations/overview',
  GetAnalyticsOverview = '/overview',
  SwitchAccount = '/switch-account',
  ResourceSearch = '/search',
  DataResidency = '/data-residency',
  OIDCAuth = '/oidc-auth',
  SiemS3 = '/integrations/s3',
  SiemHttp = '/integrations/http',
  AnalyticsDownload = '/analytics-download',
  GetNotification = '/notifications',
  GetRoles = '/roles',
  UpdateAdmin = '/update-admin',
  GetPolicyClashGroups = '/policies/clashes',
  APIKeys = '/creds',
  CASBApps = '/applications',
  CASBNeuralDLP = '/neural/dlp',
  CASBOverview = '/overview',
  CASBFiles = '/files',
  CASBFilesExport = '/files/export',
  CASBAdminConsent = '/admin-consent',
  CASBAdminConfirm = '/admin-confirm',
  CASBUnshare = '/files/unshare',
  EndpointsSearch = '/endpoints/search',
  RemoveDormantEndpoints = '/remove-dormant-endpoints',
  CASBReviewFiles = '/files/reviews',
  CustomCategories = '/custom_categories',
  Restrictions = '/restrictions',
  CASBShareStats = '/stats',
  RecategorizationStatus = '/recat',
  DLP = '/dlp',
  DLPBypass = '/dlp/bypass',
  DLPExceptions = '/dlp/exceptions',
  DLPRestrictions = '/dlp/restrictions',
  DLPDopamine = '/fe-violations/file-hash/{fileHash}/dopamine',
  SSLInspection = '/policies/{policyName}/ssl-inspection',
  SSPMNeural = '/neural/sspm',
  SSPMApps = '/apps',
  SSPMAppDetails = '/apps/{msObjectId}/details',
  SSPMOverview = '/overview',
}
